import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { archivedArticles } from "@/data/blogArticles";
import { ArrowRight } from "lucide-react";

const ArchivedArticlesPage = () => {
  return (
    <Layout>
      <SEO title="Archived Articles | Vaughan McLean" description="Browse archived news articles and legal insights from the Vaughan McLean blog." />
      <section className="pt-40 pb-24">
        <div className="container mx-auto px-8 lg:px-16">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-heading text-4xl md:text-5xl font-light tracking-wide text-foreground mb-4"
          >
            Archived Articles
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-muted-foreground font-body text-sm mb-16"
          >
            Articles by attorneys formerly associated with the firm.
          </motion.p>

          <div className="space-y-0">
            {archivedArticles.map((article, i) => (
              <motion.article
                key={article.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                viewport={{ once: true }}
              >
                <Link
                  to={`/news/${article.slug}`}
                  className="block border-b border-border py-10 group cursor-pointer hover:bg-card/50 transition-colors px-4 -mx-4"
                >
                  <p className="text-xs font-body text-muted-foreground mb-1">{article.date}</p>
                  <span className="inline-block text-[10px] tracking-[0.2em] uppercase font-body text-primary mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-2xl text-foreground group-hover:text-primary transition-colors mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-muted-foreground font-body mb-2 italic">
                    {article.author}
                  </p>
                  <p className="text-muted-foreground font-body text-sm leading-relaxed mb-3">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase font-body text-muted-foreground group-hover:text-primary transition-colors">
                    Read More <ArrowRight className="w-3 h-3" />
                  </span>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ArchivedArticlesPage;
